var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBarsProgress(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M488 352H24C10.75 352 0 362.75 0 376V456C0 469.25 10.75 480 24 480H488C501.25 480 512 469.25 512 456V376C512 362.75 501.25 352 488 352ZM464 432H289V400H464V432ZM488 192H24C10.75 192 0 202.75 0 216V296C0 309.25 10.75 320 24 320H488C501.25 320 512 309.25 512 296V216C512 202.75 501.25 192 488 192ZM464 272H161V240H464V272ZM488 32H24C10.75 32 0 42.75 0 56V136C0 149.25 10.75 160 24 160H488C501.25 160 512 149.25 512 136V56C512 42.75 501.25 32 488 32ZM464 112H353V80H464V112Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarsProgress);
export default __webpack_public_path__ + "static/media/bars-progress.cbbf55f0369e59b2a72b08a99ed9179f.svg";
export { ForwardRef as ReactComponent };